module.exports = __webpack_public_path__ + "static/img/qrcode.fca2424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.jpg
// module id = TUKC
// module chunks = 1